

// Vuex/Vue
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";

// Types
import { Contact, UserRole, UserGroup, ContactRole, UserDetails, ContactUser } from "@/store/user-management/types";
import { User } from '@/store/types';
import { GroupWithPermissions, Group } from '@/store/areas/types';

// Third Party
import vselect3 from "vselect3";
import { isEqual, cloneDeep, isEmpty } from "lodash";
import { userManagementGetters } from '@/store/user-management/getters';

// Namespaces
const UserManagement = namespace("userManagement");

@Component({})
export default class DeleteContactModal extends Vue {
    @Prop({ default: null, type: Object }) contactRole: ContactUser;
    @Prop({ default: false, type: Boolean }) modalVisible: boolean;

    @UserManagement.Action removeContact: (userId: number) => Promise<void>;

	private async deleteCurrentUser() {
        await this.removeContact(this.contactRole.userID);
        this.closeModal();
	}

    @Emit("toggle-modal")
    @Emit("contact-role")
    private closeModal() {}
}
